import { useQuery } from '@tanstack/react-query'

export const suiPriceQueryKey = () => ['suiPrice'] as const

export const useSuiPrice = () => {
  const { data, isLoading } = useQuery({
    queryKey: suiPriceQueryKey(),
    queryFn: async () => {
      const res = await fetch(
        'https://api.coingecko.com/api/v3/simple/price?ids=sui&vs_currencies=usd&include_24hr_change=true'
      )
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`)
      }
      const data = await res.json()
      return {
        price: data['sui'].usd as number,
        change24h: data['sui'].usd_24h_change as number,
      }
    },
    refetchInterval: 1000 * 60,
    staleTime: 1000 * 60,
  })

  return {
    suiPrice: data?.price,
    suiPriceChange24h: data?.change24h,
    isLoading,
  }
}
